// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c5afe05b","918":"392c4275"}[chunkId] + ".chunk.js";
};